module.exports = __webpack_public_path__ + "img/extractingback.f86ad701.png";